import { combineReducers } from "redux";

import { detailConstants } from "../actions/folders/detail";

import { downloadConstants } from "../actions/download/index";

function subjective(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS:
    return payload;
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_START:
    return null;
  case detailConstants.UPDATE_ATTACHMENTS_DETAIL_SUCCESS:
    // ho bisogno delle info per recuperare le info dell'allegato
    return { ...defaultState, attachmentsDetail: payload };
  case downloadConstants.DOCUMENT_DOWNLOAD_SUCCESS: {
    let updatedContentOriginal =
        defaultState && defaultState.attachmentsDetail
          ? defaultState.attachmentsDetail.find((el) => {
            return el.documentId === payload.docId;
          })
          : [];
    updatedContentOriginal["contentOriginal"] = payload.data.content;
    return { ...defaultState };
  }
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_SUCCESS:
    return { ...defaultState, attachments: payload };
  case detailConstants.CLEAR_SUBJECTIVE_FOLDER_DETAIL:
    return null;
  default:
    return defaultState;
  }
}

function documents(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case detailConstants.GET_FOLDER_DOCUMENT_SUCCESS:
    let docId = payload.documentId;
    return { ...defaultState, [docId]: { ...payload } };
  default:
    return defaultState;
  }
}

function preview(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS:
    return payload.content;
  case detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_START:
  case detailConstants.CLEAR_SUBJECTIVE_FOLDER_PREVIEW: {
    return null;
  }
  default:
    return defaultState;
  }
}

function isLoadingPreview(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_START:
    return true;
  case detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS:
  case detailConstants.GET_PREVIEW_FOLDER_DOCUMENT_ERROR:
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isLoadingDocument(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_FOLDER_DOCUMENT_START:
    return true;
  case detailConstants.GET_FOLDER_DOCUMENT_SUCCESS:
  case detailConstants.GET_FOLDER_DOCUMENT_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isDownloadingFolder(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_FOLDER_DOWNLOAD_START:
    return payload.id;
  case detailConstants.GET_FOLDER_DOWNLOAD_SUCCESS:
  case detailConstants.GET_FOLDER_DOWNLOAD_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isGettingSubjectiveFolder(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_START:
    return true;
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS:
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isGettingSubjectiveFolderDetail(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_START:
    return true;
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS:
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isGettingSubjectiveFolderDetailContent(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_START:
    return true;
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_SUCCESS:
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_CONTENT_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingSubjectiveStatistics(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_ERROR:
    return error || {};
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_START:
  case detailConstants.GET_SUBJECTIVE_FOLDER_DETAIL_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

export const foldersDetail = combineReducers({
  subjective,
  documents,
  preview,
  isGettingSubjectiveFolder,
  isGettingSubjectiveFolderDetail,
  isGettingSubjectiveFolderDetailContent,
  isErrorGettingSubjectiveStatistics,
  isLoadingPreview,
  isLoadingDocument,
  isDownloadingFolder
});

export default foldersDetail;
